export const generateLabel = (row:any)=>{ return row?.labels?.length > 0 ? row.labels.map((label:any)=> label.name ).join(',') : " " }
